/**
 * Typography configuration based on the existing CSS custom properties
 */
export const typography = {
  fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", sans-serif',
  fontFamilyMono: '"JetBrains Mono", "SF Mono", "Monaco", "Inconsolata", "Roboto Mono", monospace',
  fontWeightThin: 100,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightSemiBold: 600,
  fontWeightBold: 700,
  fontWeightExtraBold: 800,
  fontWeightBlack: 900,
  
  h1: {
    fontWeight: 700,
    fontSize: '3rem', // 48px
    lineHeight: 1.2,
  },
  h2: {
    fontWeight: 700,
    fontSize: '2.25rem', // 36px
    lineHeight: 1.2,
  },
  h3: {
    fontWeight: 600,
    fontSize: '1.875rem', // 30px
    lineHeight: 1.3,
  },
  h4: {
    fontWeight: 600,
    fontSize: '1.5rem', // 24px
    lineHeight: 1.35,
  },
  h5: {
    fontWeight: 600,
    fontSize: '1.25rem', // 20px
    lineHeight: 1.4,
  },
  h6: {
    fontWeight: 600,
    fontSize: '1.125rem', // 18px
    lineHeight: 1.45,
  },
  subtitle1: {
    fontSize: '1rem', // 16px
    lineHeight: 1.5,
    fontWeight: 500,
  },
  subtitle2: {
    fontSize: '0.875rem', // 14px
    lineHeight: 1.5,
    fontWeight: 500,
  },
  body1: {
    fontSize: '1rem', // 16px
    lineHeight: 1.5,
  },
  body2: {
    fontSize: '0.875rem', // 14px
    lineHeight: 1.5,
  },
  button: {
    fontSize: '0.875rem', // 14px
    fontWeight: 600,
    lineHeight: 1.5,
    textTransform: 'none',
  },
  caption: {
    fontSize: '0.75rem', // 12px
    lineHeight: 1.5,
  },
  overline: {
    fontSize: '0.75rem', // 12px
    fontWeight: 600,
    lineHeight: 1.5,
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
  },
};